var PortafoliosDataGrid;
(function (PortafoliosDataGrid) {
    class ResizeGridColumns {
        constructor(_dotNetObj, _containerId) {
            this.dotNetObject = null;
            this.containerId = null;
            this.mainContainer = null;
            this.isResizing = false;
            this.clientXStartPoint = -1;
            this.startWidth = -1;
            this.indexResizing = -1;
            this.thResizing = null;
            this.thHandle = null;
            this.resizeWidthDisplayer = null;
            this.mouseDownRefs = [];
            this.containerId = _containerId;
            this.dotNetObject = _dotNetObj;
            this.mainContainer = document.getElementById(this.containerId);
            this.resizeWidthDisplayer = document.getElementById('wd_' + this.containerId);
            var handlers = this.mainContainer.querySelectorAll('.resize-handle');
            handlers.forEach((a) => {
                let mouseDown = (args) => this.mouseDown(args);
                let htmlEl = a;
                this.mouseDownRefs.push({ listener: mouseDown, element: htmlEl });
                htmlEl.addEventListener('mousedown', mouseDown);
            });
            this.mouseMoveRef = (e) => this.mouseMove(e);
            this.mouseUpRef = (e) => this.mouseUp(e);
            document.addEventListener('mousemove', this.mouseMoveRef);
            document.addEventListener('mouseup', this.mouseUpRef);
            if (this.mainContainer != null) {
                var tableHeaders = this.mainContainer.querySelectorAll('th');
                tableHeaders.forEach(a => {
                    var width = a.getAttribute('data-initial-width');
                    if (width) {
                        a.style.width = width + "px";
                    }
                });
                this.updateTableWidth();
            }
        }
        setWidth(columna, width) {
            var thResizing = this.mainContainer.getElementsByClassName('catTh_' + columna)[0];
            if (thResizing) {
                thResizing.style.width = width + "px";
                thResizing.setAttribute('data-initial-width', width.toFixed(0));
                this.updateTableWidth();
            }
        }
        updateTableWidth() {
            var table = this.mainContainer.querySelector('table');
            var theadRow = this.mainContainer.querySelector('thead tr');
            if (!table || !theadRow)
                return;
            var totalWidth = 0;
            for (var i = 0; i < theadRow.children.length; i++) {
                var th = theadRow.children[i];
                if (th.classList.contains('grid-filler-column'))
                    continue;
                var auxWidth = parseInt(th.style.width.replace("px", ""));
                if (!Number.isFinite(auxWidth)) {
                    auxWidth = Math.round(th.getBoundingClientRect().width);
                }
                totalWidth += auxWidth;
            }
            table.style.width = "100%";
            table.style.minWidth = totalWidth + "px";
            table.style.maxWidth = "";
        }
        mouseDown(args) {
            args.stopPropagation();
            if (!this.isResizing) {
                this.isResizing = true;
                this.clientXStartPoint = args.clientX;
                this.thHandle = args.target;
                this.thResizing = this.thHandle.parentElement;
                this.startWidth = parseFloat(this.thResizing.style.width.replace("px", ""));
                this.indexResizing = parseInt(this.thHandle.getAttribute('data-column-index'));
                this.thHandle.classList.add('bg-primary');
                this.resizeWidthDisplayer.innerHTML = this.startWidth.toFixed(0);
                args.preventDefault();
            }
        }
        mouseMove(args) {
            args.stopPropagation();
            if (this.isResizing) {
                var dx = args.clientX - this.clientXStartPoint;
                var final = this.startWidth + dx;
                this.thResizing.style.width = final.toFixed(0) + "px";
                this.updateTableWidth();
                this.resizeWidthDisplayer.innerHTML = final.toFixed(0);
                args.preventDefault();
            }
        }
        mouseUp(args) {
            args.stopPropagation();
            if (this.isResizing) {
                this.isResizing = false;
                var width = parseInt(this.thResizing.style.width.replace("px", ""));
                this.dotNetObject.invokeMethodAsync('ActualizarAnchoColumna', this.indexResizing, width);
                this.thHandle.classList.remove('bg-primary');
                this.resizeWidthDisplayer.innerHTML = '';
                args.preventDefault();
            }
        }
        dispose() {
            for (var i = 0; i < this.mouseDownRefs.length; i++) {
                this.mouseDownRefs[i].element.removeEventListener('mousedown', this.mouseDownRefs[i].listener);
            }
            document.removeEventListener('mousemove', this.mouseMoveRef);
            document.removeEventListener('mouseup', this.mouseUpRef);
        }
        static crearInstancia(_dotNetObj, _containerId) {
            let htmlEl = document.getElementById(_containerId);
            if (!htmlEl) {
                return;
            }
            let found = ResizeGridColumns.CurrentInstances.filter(a => a.containerId == _containerId);
            if (found.length > 0) {
                let arrIndex = ResizeGridColumns.CurrentInstances.indexOf(found[0]);
                found[0].dispose();
                delete found[0];
                ResizeGridColumns.CurrentInstances.splice(arrIndex, 1);
            }
            let newInstance = new ResizeGridColumns(_dotNetObj, _containerId);
            ResizeGridColumns.CurrentInstances.push(newInstance);
            return newInstance;
        }
    }
    ResizeGridColumns.CurrentInstances = [];
    PortafoliosDataGrid.ResizeGridColumns = ResizeGridColumns;
})(PortafoliosDataGrid || (PortafoliosDataGrid = {}));
